
import { handleError } from '../context/errors/errorUtils';

// возвращает объект аудио 
export const playUserAudio = (url, dispatch, onEnded, onError) => {
  const audio = new Audio(url);
  audio.onended = onEnded;
  audio.onerror = (event) => {
    handleError({
      code: 'AUDIO_PLAYBACK_ERROR',
      error: new Error('Ошибка воспроизведения аудио'),
      context: { url },
      showToUser: false,
      dispatch,
    });
    onError?.(event);
  };

  audio.play().catch((error) => {
    handleError({
      code: 'AUDIO_PLAY_FAILED',
      error,
      context: { url },
      showToUser: false,
      dispatch,
    });
    onError?.(error);
  });

  return audio;
};

export const toggleTranslation = (dispatch, id) => {
  dispatch({ type: 'TOGGLE_TRANSLATION', payload: id });
};